/* eslint-disable no-console */
import {Col, Form, Input} from 'antd';
import React from 'react';

import {CommonErrors} from '../../../../constants/Common';
import NumberInput from '../../../../shared/NumberInput';
import RegEx from '../../../../utils/FormUtils/RegEx';
import {
  OPKey,
  OPLabel,
  OPplaceholder
} from '../orgInfo/constants/orgProfileKeyLabel';

const CountryWiseCreds: React.FC<{country: number; colSpan: number, isHeadquarter?: boolean}> = ({
  country,
  colSpan,
  isHeadquarter 
}) => {
  const countryCredKeys = isHeadquarter ? {
    tax: ['company', OPKey.IDENTITY],
    company: ['company', OPKey.COMPANY],
    gst: ['company', OPKey.TAX],
    nino: ['company', OPKey.NINO],
    crn: ['company', OPKey.CRN],
    vat: ['company', OPKey.VAT]
  }:
  {
    tax: OPKey.IDENTITY,
    company: OPKey.COMPANY,
    gst: OPKey.TAX,
    nino: OPKey.NINO,
    crn: OPKey.CRN,
    vat: OPKey.VAT
  };

  switch (country) {
    case 101:
      return (
        <>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.tax}
              label={OPLabel.PAN}
              rules={[
               // {required: true, message: CommonErrors.mandatory(OPLabel.PAN)},
                {
                  pattern: RegEx.PAN,
                  message: CommonErrors.validDigitField(OPLabel.PAN, 10)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.toUpperCase();
                }}
                placeholder={`Enter ${OPplaceholder.PAN}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.gst}
              label={OPLabel.GST}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.GST)},
                {
                  pattern: RegEx.GST,
                  message: CommonErrors.validDigitField(OPLabel.GST, 15)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.toUpperCase();
                }}
                placeholder={`Enter ${OPplaceholder.GST}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.company}
              label={OPLabel.CIN}
              rules={[
               // {required: true, message: CommonErrors.mandatory(OPLabel.CIN)},
                {
                  pattern: RegEx.CIN,
                  message: CommonErrors.validDigitField(OPLabel.CIN, 21)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.toUpperCase();
                }}
                placeholder={`Enter ${OPplaceholder.CIN}`}
              />
            </Form.Item>
          </Col>
        </>
      );
    case 233:
      return (
        <>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.tax}
              label={OPLabel.SSN}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.SSN)},
                {
                  pattern: RegEx.SSN,
                  message: CommonErrors.validDigitField(OPLabel.SSN, 9)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${OPplaceholder.SSN}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.company}
              label={OPLabel.EIN}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.EIN)},
                {
                  pattern: RegEx.EIN,
                  message: CommonErrors.validDigitField(OPLabel.EIN, 9)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${OPplaceholder.EIN}`} />
            </Form.Item>
          </Col>
        </>
      );
    case 109:
      return (
        <>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.tax}
              label={OPLabel.IDENTIY_NUMBER}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.IDENTIY_NUMBER)
                },
                {
                  pattern: RegEx.IN,
                  message: CommonErrors.validDigitField(
                    OPLabel.IDENTIY_NUMBER,
                    12
                  )
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${OPplaceholder.IDENTIY_NUMBER}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.company}
              label={OPLabel.CORP_NUM}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(OPLabel.CORP_NUM)
                },
                {
                  pattern: RegEx.CN,
                  message: CommonErrors.validDigitField(OPLabel.CORP_NUM, 13)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${OPplaceholder.CORP_NUM}`} />
            </Form.Item>
          </Col>
        </>
      );
    case 232:
      return (
        <>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.nino}
              label={OPLabel.NINO}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.NINO)},
                {
                  pattern: RegEx.NINO,
                  message: CommonErrors.validDigitField(OPLabel.NINO, 9)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.toUpperCase();
                }}
                placeholder={OPplaceholder.NINO}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.crn}
              label={OPLabel.CRN}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.CRN)},
                {
                  pattern: RegEx.CRN,
                  message: CommonErrors.validDigitField(OPLabel.CRN, 8)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.toUpperCase();
                }}
                placeholder={OPplaceholder.CRN}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={colSpan}>
            <Form.Item
              name={countryCredKeys.vat}
              label={OPLabel.VAT}
              rules={[
                {required: true, message: CommonErrors.mandatory(OPLabel.VAT)},
                {
                  pattern: RegEx.VAT,
                  message: `Please enter either 9 or 12 digit valid ${OPLabel.VAT} number`
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <NumberInput
                placeholder={OPplaceholder.VAT}
                isFormatted={false}
              />
            </Form.Item>
          </Col>
        </>
      );
    default:
      return <></>;
  }
};

export default CountryWiseCreds;
